var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_231_176",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0C63.6437 0 82 18.3563 82 41Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7328 19.1033C42.147 18.5175 41.1973 18.5175 40.6115 19.1033L31.0655 28.6492C30.4797 29.235 30.4797 30.1847 31.0655 30.7705C31.6513 31.3563 32.6011 31.3563 33.1868 30.7705L41.6721 22.2853L50.1574 30.7705C50.7432 31.3563 51.6929 31.3563 52.2787 30.7705C52.8645 30.1847 52.8645 29.235 52.2787 28.6492L42.7328 19.1033ZM43.1721 63.1803V20.1639H40.1721V63.1803H43.1721ZM79 41C79 61.9868 61.9868 79 41 79V85C65.3005 85 85 65.3005 85 41H79ZM41 79C20.0132 79 3 61.9868 3 41H-3C-3 65.3005 16.6995 85 41 85V79ZM3 41C3 20.0132 20.0132 3 41 3V-3C16.6995 -3 -3 16.6995 -3 41H3ZM41 3C61.9868 3 79 20.0132 79 41H85C85 16.6995 65.3005 -3 41 -3V3Z",
    fill: "#F07751",
    mask: "url(#path-1-inside-1_231_176)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.ef2ada6d58f263315b64b327dfe200b5.svg";
export { ForwardRef as ReactComponent };